import { config } from "../config";

export function generateUniversalLinkForCode(p: { code: string }): string {
  return `${config.universalLinkHttpBase}/${p.code.substr(0, 3)}-${p.code.substr(3, 3)}-${p.code.substr(6, 3)}`;
}

export function generateUniversalLinkBase(): string {
  return `${config.universalLinkHttpBase}`;
}
